export default __webpack_public_path__ + "static/media/FormingImg.4477f0ae.jpg";